

import React, { useState, useEffect, useMemo } from 'react'; // CORREÇÃO 1: useMemo importado
import { GridContainer } from '../../global';
import { BlogBanner, BlogCard, BlogGrid, CardContent, 
    FilterContainer, FilterButton, TagBadge, TagList, CategoryBadge, ShowMoreButton  } from './style'; 

const SPACE_ID = 'js0jco2wnv88';
const ACCESS_TOKEN = '7iNOSfMbMjQFx6ffcZmKI8iuXt9CWsWkYfK5PrqifoE';

const CATEGORIES = ["Artigos sobre a Renovera", "Notícias", "Estudos Técnicos"];

const TAG_LIMIT = 10;

const getCategoryStyle = (categoryName) => {
    switch (categoryName) {
        case 'Artigos sobre a Renovera':
            return { bgColor: '#02391E', textColor: '#FFFFFF' };
        case 'Notícias':
            return { bgColor: '#FFB81C', textColor: '#000000' };
        case 'Estudos Técnicos':
            return { bgColor: '#4A4A4A', textColor: '#FFFFFF' };
        default:
            return { bgColor: '#cccccc', textColor: '#333333' };
    }
};

function Blog() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    const [selectedCategory, setSelectedCategory] = useState('Todos');
    const [selectedTag, setSelectedTag] = useState(null);
    const [sortOrder, setSortOrder] = useState('newest');
    const [showAllTags, setShowAllTags] = useState(false);

    useEffect(() => {
        const url = `https://cdn.contentful.com/spaces/${SPACE_ID}/environments/master/entries?access_token=${ACCESS_TOKEN}&content_type=post`;

        fetch(url)
            .then(response => response.json())
            .then(data => {
                const linkedAssets = data.includes?.Asset || [];
                const allPosts = data.items
                    .map(post => {
                        if (post.fields.imagemDestacada?.sys?.id) {
                            const imageId = post.fields.imagemDestacada.sys.id;
                            const imageData = linkedAssets.find(asset => asset.sys.id === imageId);
                            if (imageData?.fields?.file?.url) {
                                return {
                                    ...post,
                                    imageUrl: 'https:' + imageData.fields.file.url
                                };
                            }
                        }
                        return null;
                    })
                    .filter(post => post !== null); 

                setPosts(allPosts);
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar posts:", error);
                setLoading(false);
            });
    }, []);

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString('pt-BR', options);
    };

    const filteredAndSortedPosts = useMemo(() => {
        return posts
            .filter(post => {
                const categoryMatch = selectedCategory === 'Todos' || post.fields.categoria === selectedCategory;
                const tagMatch = !selectedTag || (post.fields.tags && post.fields.tags.includes(selectedTag));
                return categoryMatch && tagMatch;
            })
            .sort((a, b) => {
                const dateA = new Date(a.fields.dataDePublicao);
                const dateB = new Date(b.fields.dataDePublicao);
                return sortOrder === 'newest' ? dateB - dateA : dateA - dateB;
            });
    }, [posts, selectedCategory, selectedTag, sortOrder]);

    const allTags = useMemo(() => {
        const tagsSet = new Set();
        posts.forEach(post => {
            if (post.fields.tags) {
                post.fields.tags.forEach(tag => tagsSet.add(tag));
            }
        });
        return Array.from(tagsSet).sort(); 
    }, [posts]);

    
    return (
        <div>
            <BlogBanner>
                <h1>Blog</h1>
                <p>Fique por dentro de tudo o que está acontecendo no mercado de energia solar!</p>
            </BlogBanner>
            
            <GridContainer>
                {/* --- SEÇÃO DE FILTROS --- */}
                <FilterContainer>
                    <div>
                        <strong>Categorias:</strong>
                        <FilterButton active={selectedCategory === 'Todos'} onClick={() => { setSelectedCategory('Todos'); setSelectedTag(null); }}>Todos</FilterButton>
                        {CATEGORIES.map(cat => (
                            <FilterButton key={cat} active={selectedCategory === cat} onClick={() => { setSelectedCategory(cat); setSelectedTag(null); }}>
                                {cat}
                            </FilterButton>
                        ))}
                    </div>
                     <div>
                        <strong>Ordenar por: </strong>
                        <select onChange={(e) => setSortOrder(e.target.value)} value={sortOrder}>
                            <option value="newest">Mais Recentes</option>
                            <option value="oldest">Mais Antigos</option>
                        </select>
                    </div>
                </FilterContainer>

               <FilterContainer>
                     <div>
                        <strong>Tags:</strong>
                      
                        {(showAllTags ? allTags : allTags.slice(0, TAG_LIMIT)).map(tag => (
                           <TagBadge key={tag} as="button" active={selectedTag === tag} onClick={() => setSelectedTag(prev => prev === tag ? null : tag)}>
                                {tag}
                           </TagBadge>
                        ))}
                        
                        {allTags.length > TAG_LIMIT && (
                            <ShowMoreButton onClick={() => setShowAllTags(!showAllTags)}>
                                {showAllTags ? 'Ver Menos' : `Ver Mais (${allTags.length - TAG_LIMIT})`}
                            </ShowMoreButton>
                        )}
                     </div>
                </FilterContainer>


               {loading ? (
                    <p style={{textAlign: "center", padding: "50px"}}>Carregando posts...</p>
                ) : (
                    <BlogGrid>
                        {filteredAndSortedPosts.map(post => {
                        
                            const categoryStyle = getCategoryStyle(post.fields.categoria);

                            return (
                                <BlogCard key={post.sys.id} to={`/blog/${post.fields.slug}`} state={{ allPosts: posts }}>
                                    <img 
                                        src={post.imageUrl} 
                                        alt={post.fields.titulo} 
                                    />
                                    <CardContent>
                                   
                                        <CategoryBadge bgColor={categoryStyle.bgColor} textColor={categoryStyle.textColor}>
                                            {post.fields.categoria}
                                        </CategoryBadge>

                                        <h3>{post.fields.titulo}</h3>
                                        <p>{post.fields.resumo}</p>
                                        
                                      
                                        <div className="card-footer">
                                            <TagList>
                                                {post.fields.tags && post.fields.tags.slice(0, 2).map(tag => <TagBadge key={tag}>{tag}</TagBadge>)}
                                            </TagList>
                                            <span>{formatDate(post.fields.dataDePublicao)}</span>
                                        </div>
                                    </CardContent>
                                </BlogCard>
                            );
                        })}
                    </BlogGrid>
                )}
            </GridContainer>
        </div>
    );
}

export default Blog;